var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import query from 'syf-component-library/const/mediaQueries';
import { spacing } from 'syf-component-library/defaultTheme';
import { Inset } from 'syf-component-library/ui/spacing';
var DrawerHeaderWrapper = styled(Inset)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  @media ", " {\n    padding: ", "px ", "px;\n  }\n"], ["\n  @media ", " {\n    padding: ", "px ", "px;\n  }\n"])), query.lessThanMedium, spacing.small, spacing.base);
export default DrawerHeaderWrapper;
var templateObject_1;
